// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1MLHd","itemTitle":"ClientEmergencyInfo_itemTitle__G21pz","itemText":"ClientEmergencyInfo_itemText__2cRgu"};